import {Injectable} from '@angular/core'

@Injectable()
export class FloatObjectService {
  constructor() {
  }

  selectPosition(position) {
    let positionElement
    switch (position) {
      case 'right_up':
        positionElement = {top: '15px'}
        break
      case 'right_middle':
        positionElement = {top: '50%'}
        break
      case 'right_down':
        positionElement = {bottom: '15px'}
        break
      default:
        positionElement = {bottom: '20px'}
    }
    return positionElement
  }
}
